// extracted by mini-css-extract-plugin
export default {"displayName":"Form_displayName__0W0QR","optionRow":"Form_optionRow__x8jTc","selectedOption":"Form_selectedOption__CBygT","deleteBtn":"Form_deleteBtn__nArl2"};